import "../styles/app.css";

export default function Layout({ title, right, children }) {
  return (
    <div className="app">
      <div className="topbar">
        <div className="title">{title}</div>
        <div>{right}</div>
      </div>
      <div className="container">{children}</div>
    </div>
  );
}